import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { TruckIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function QuotePage() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    pickup: '',
    delivery: '',
    serviceType: '',
    urgency: '',
    details: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Quote Requested:', formData);
    alert('Quote request submitted successfully! Our team will contact you shortly.');
    setFormData({
      name: '',
      company: '',
      pickup: '',
      delivery: '',
      serviceType: '',
      urgency: '',
      details: ''
    });
  };
  return <main className="bg-slate-50 min-h-screen pb-20" data-id="element-321">
      {/* Hero Banner */}
      <section className="bg-primary py-16 text-center px-4" data-id="element-322">
        <div className="container mx-auto max-w-3xl" data-id="element-323">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-324">
            Get a Quote
          </h1>
          <p className="text-xl text-blue-100" data-id="element-325">
            Fill out the form below and we'll provide a competitive quote for
            your logistics needs.
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 max-w-6xl mt-12" data-id="element-326">
        <div className="flex flex-col lg:flex-row gap-8" data-id="element-327">
          {/* Form Section */}
          <div className="lg:w-2/3 bg-white rounded-2xl shadow-lg border border-slate-100 p-8 md:p-10" data-id="element-328">
            <h2 className="text-2xl font-bold text-slate-900 mb-8 pb-4 border-b" data-id="element-329">
              Quote Request Details
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-330">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-331">
                <div data-id="element-332">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-333">
                    Full Name *
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-slate-50 focus:bg-white" placeholder="John Doe" data-id="element-334" />
                </div>
                <div data-id="element-335">
                  <label htmlFor="company" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-336">
                    Company (Optional)
                  </label>
                  <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-slate-50 focus:bg-white" placeholder="Your Company Ltd" data-id="element-337" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-338">
                <div data-id="element-339">
                  <label htmlFor="pickup" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-340">
                    Pickup Location *
                  </label>
                  <input type="text" id="pickup" name="pickup" required value={formData.pickup} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-slate-50 focus:bg-white" placeholder="Postcode or City" data-id="element-341" />
                </div>
                <div data-id="element-342">
                  <label htmlFor="delivery" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-343">
                    Delivery Location *
                  </label>
                  <input type="text" id="delivery" name="delivery" required value={formData.delivery} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-slate-50 focus:bg-white" placeholder="Postcode or City" data-id="element-344" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-345">
                <div data-id="element-346">
                  <label htmlFor="serviceType" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-347">
                    Type of Service *
                  </label>
                  <select id="serviceType" name="serviceType" required value={formData.serviceType} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-slate-50 focus:bg-white" data-id="element-348">
                    <option value="" data-id="element-349">Select service type</option>
                    <option value="parcel" data-id="element-350">Parcel Delivery</option>
                    <option value="pallet" data-id="element-351">Pallet Delivery</option>
                    <option value="furniture" data-id="element-352">Furniture Transport</option>
                    <option value="relocation" data-id="element-353">Relocation Services</option>
                    <option value="driver" data-id="element-354">Contract Driver</option>
                  </select>
                </div>
                <div data-id="element-355">
                  <label htmlFor="urgency" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-356">
                    Urgency Level *
                  </label>
                  <select id="urgency" name="urgency" required value={formData.urgency} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-slate-50 focus:bg-white" data-id="element-357">
                    <option value="" data-id="element-358">Select urgency</option>
                    <option value="standard" data-id="element-359">Standard (2-3 Days)</option>
                    <option value="next-day" data-id="element-360">Next Day</option>
                    <option value="same-day" data-id="element-361">Same Day</option>
                    <option value="emergency" data-id="element-362">Emergency (ASAP)</option>
                  </select>
                </div>
              </div>

              <div data-id="element-363">
                <label htmlFor="details" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-364">
                  Additional Details
                </label>
                <textarea id="details" name="details" rows={4} value={formData.details} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all bg-slate-50 focus:bg-white resize-none" placeholder="Please provide details about size, weight, or specific requirements..." data-id="element-365"></textarea>
              </div>

              <div className="pt-4" data-id="element-366">
                <Button type="submit" size="lg" className="w-full text-lg py-6" data-id="element-367">
                  Request Quote
                </Button>
                <p className="text-center text-sm text-slate-500 mt-4" data-id="element-368">
                  We aim to respond to all quote requests within 30 minutes
                  during business hours.
                </p>
              </div>
            </form>
          </div>

          {/* Side Panel */}
          <div className="lg:w-1/3 space-y-6" data-id="element-369">
            <div className="bg-slate-900 text-white rounded-2xl p-8 shadow-lg" data-id="element-370">
              <h3 className="text-xl font-bold mb-6" data-id="element-371">Why Request a Quote?</h3>
              <ul className="space-y-4" data-id="element-372">
                <li className="flex items-start" data-id="element-373">
                  <ClockIcon className="h-6 w-6 text-primary mr-3 shrink-0" data-id="element-374" />
                  <span data-id="element-375">Fast response times to all enquiries</span>
                </li>
                <li className="flex items-start" data-id="element-376">
                  <ShieldCheckIcon className="h-6 w-6 text-primary mr-3 shrink-0" data-id="element-377" />
                  <span data-id="element-378">Transparent pricing with no hidden fees</span>
                </li>
                <li className="flex items-start" data-id="element-379">
                  <TruckIcon className="h-6 w-6 text-primary mr-3 shrink-0" data-id="element-380" />
                  <span data-id="element-381">Tailored solutions for your specific needs</span>
                </li>
              </ul>
            </div>

            <div className="bg-blue-50 border border-blue-100 rounded-2xl p-8" data-id="element-382">
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-383">
                Need Immediate Help?
              </h3>
              <p className="text-slate-600 mb-4" data-id="element-384">
                For emergency deliveries, please call us directly for the
                fastest response.
              </p>
              <a href="tel:08001234567" className="inline-flex items-center justify-center w-full bg-white border-2 border-primary text-primary font-bold py-3 rounded-lg hover:bg-primary hover:text-white transition-colors" data-id="element-385">
                Call 0800 123 4567
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>;
}